/** Mastra `writer.custom` SSE chunk types forwarded to the member app. */
export const DATA_UI_CHUNK_TYPE = 'data-ui';
export const DATA_OFF_TOPIC_CHUNK_TYPE = 'data-off-topic';
export const DATA_THREAD_METRICS_CHUNK_TYPE = 'data-thread-metrics';
export const DATA_SUPPORT_ESCALATION_CHUNK_TYPE = 'data-support-escalation';
